
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";

export const useUserRole = (user: User | null) => {
  const [role, setRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('users')
          .select('role')
          .eq('email', user.email)
          .single();

        if (fetchError) {
          console.error('Error fetching user role:', fetchError);
          setError('Failed to fetch user role');
          return;
        }

        setRole(data?.role || null);
      } catch (err) {
        console.error('Error in fetchUserRole:', err);
        setError('Failed to fetch user role');
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, [user?.email]);

  return { role, loading, error };
};
